import type {RaqsciCode} from "../types/categoryRecordTypes";

/**
 * "Suggest from the text" (spec 4.4): tag a requirement with the RAQSCI criterion whose keywords it mentions most.
 * Keyword stems, matched case-insensitively at the start of a word. A suggestion only: the user picks.
 */
const KEYWORDS: Record<RaqsciCode, string[]> = {
    R: ['regulat', 'complian', 'law', 'legal', 'legislat', 'gdpr', 'iso', 'certif', 'permit', 'licen', 'reach',
        'rohs', 'directive', 'mandatory', 'sanction', 'esg report'],
    A: ['supply', 'lead time', 'lead-time', 'capacity', 'continuity', 'stock', 'inventory', 'backup', 'dual sourc',
        'second source', 'resilien', 'shortage', 'allocation', 'on-time', 'on time', 'delivery'],
    Q: ['quality', 'defect', 'tolerance', 'inspection', 'audit', 'ppm', 'reject', 'specification', 'sample',
        'traceab', 'calibrat', 'grade', 'hygien'],
    S: ['service', 'sla', 'response time', 'support', 'helpdesk', 'uptime', 'account manag', 'escalat',
        'availability', 'report', 'kpi', 'training', 'hours'],
    C: ['cost', 'price', 'pricing', 'budget', 'saving', 'tco', 'discount', 'rebate', 'payment term', 'invoice',
        'index', 'fee', 'tariff', 'cheaper'],
    I: ['innovat', 'technolog', 'roadmap', 'digital', 'automat', 'r&d', 'co-develop', 'pilot', 'new product',
        'sustainab', 'circular', 'ai '],
};

const ORDER: RaqsciCode[] = ['R', 'A', 'Q', 'S', 'C', 'I'];

function count(text: string, stem: string): number {
    const escaped = stem.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return (text.match(new RegExp(`(^|[^a-z])${escaped}`, 'g')) ?? []).length;
}

/** The best-matching criterion, or null when no keyword appears. Ties go to the earlier letter in RAQSCI. */
export function suggestCriterion(text: string): RaqsciCode | null {
    const lower = ` ${text.toLowerCase()} `;
    let best: RaqsciCode | null = null;
    let bestScore = 0;
    for (const code of ORDER) {
        const score = KEYWORDS[code].reduce((sum, stem) => sum + count(lower, stem), 0);
        if (score > bestScore) {
            best = code;
            bestScore = score;
        }
    }
    return best;
}
